import { TableCell, TableRow } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTableSortLabel } from 'src/components/CustomTableSortLabel';
import { SORT_DIRECTION } from 'src/data/common';
import { PROJECT_TABLE_FIELD } from 'src/data/project';

import { useStyles } from './useStyles';

export const HeaderRow = ({
  onSortChange,
  sortField,
  sortOrder,
  hideActions,
  hideSort,
  nameOnly,
}) => {
  const styles = useStyles();

  const createSortHandler = (field) => () => {
    onSortChange(field);
  };

  return (
    <TableRow>
      {!hideActions && <TableCell className={cx(styles.cell, styles.cellFavorite)}></TableCell>}

      <TableCell className={cx(styles.cell, styles.cellName)}>
        {hideSort ? (
          'Name'
        ) : (
          <CustomTableSortLabel
            active={sortField === PROJECT_TABLE_FIELD.name}
            direction={sortField === PROJECT_TABLE_FIELD.name ? sortOrder : SORT_DIRECTION.asc}
            onClick={createSortHandler(PROJECT_TABLE_FIELD.name)}
          >
            Name
          </CustomTableSortLabel>
        )}
      </TableCell>

      {!nameOnly && (
        <>
          <TableCell className={cx(styles.cell, styles.cellType)}>Content types</TableCell>

          <TableCell className={cx(styles.cell, styles.cellDescription)}>
            {hideSort ? (
              'Last modified'
            ) : (
              <CustomTableSortLabel
                active={sortField === PROJECT_TABLE_FIELD.updated_at}
                direction={
                  sortField === PROJECT_TABLE_FIELD.updated_at ? sortOrder : SORT_DIRECTION.asc
                }
                onClick={createSortHandler(PROJECT_TABLE_FIELD.updated_at)}
              >
                Last modified
              </CustomTableSortLabel>
            )}
          </TableCell>
        </>
      )}

      {!hideActions && <TableCell className={cx(styles.cell, styles.cellMenu)}></TableCell>}
    </TableRow>
  );
};

HeaderRow.propTypes = {
  onSortChange: PropTypes.func,
  sortField: PropTypes.string,
  sortOrder: PropTypes.string,
  hideActions: PropTypes.bool,
  hideSort: PropTypes.bool,
  nameOnly: PropTypes.bool,
};

HeaderRow.defaultProps = {
  onSortChange: null,
  sortField: null,
  sortOrder: null,
  hideActions: false,
  hideSort: false,
  nameOnly: false,
};
